import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ExternalTaskSchema } from './shapes';

/** Resolve UCHAT / UCHAT3 custom ids or raw ids (ClickUp), or UCH ids (Linear, read-only). */
export const resolveReleaseTask = defineEndpoint({
  method: 'GET',
  path: '/v1/release-tasks/resolve',
  params: z.object({}),
  query: z.object({ ref: z.string().trim().min(1).max(64) }),
  body: z.undefined(),
  response: z.object({ data: ExternalTaskSchema }),
});
